// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import styled, { css } from "styled-components";
// Store Custom Code
import { autocompleteProps } from "@store/Themes/common/props/autocomplete";
import Search from "@store/Library/Components/Toolkit/Icons/Search";
import Icon from "@insite/mobius/Icon";

interface Props {
    suggestions: AutocompleteItemModel[] | null;
    focusedItem?: AutocompleteItemModel;
    goToUrl: (url: string) => void;
    extendedStyles?: AutocompleteSuggestionsStyles;
    // Store Custom Code - fills the search box with the suggestion text
    onPopulate?: (text: string) => void;
    // Store Custom Code - hide the "Search" header (2-column view); shown in the products view
    hideHeader?: boolean;
}

export interface AutocompleteSuggestionsStyles {
    headerText?: TypographyPresentationProps;
    divider?: InjectableCss;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
}

export const autocompleteSuggestionStyles: AutocompleteSuggestionsStyles = {
    // Store Custom Code - use the shared autocomplete styles so suggestions match categories/brands
    headerText: autocompleteProps.headerText,
    link: autocompleteProps.link,
    focusedLink: autocompleteProps.focusedLink,
};

const styles = autocompleteSuggestionStyles;

/* Store Custom Code - a leading search icon before each suggestion */
const SuggestionRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    > a {
        flex: 1;
        min-width: 0;
    }
`;

/* Store Custom Code - fill-search (populate) button */
const PopulateButton = styled.button`
    margin-left: auto;
    flex-shrink: 0;
    background: none;
    border: none;
    cursor: pointer;
    color: #b0b4b8;
    font-size: 20px;
    line-height: 1;
    padding: 4px 0 4px 8px;
`;

class AutocompleteSuggestions extends React.Component<Props> {
    private readonly styles: AutocompleteSuggestionsStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);
    }

    render() {
        const { suggestions } = this.props;
        if (!suggestions || suggestions.length === 0) {
            return null;
        }

        const styles = this.styles;
        return (
            <>
                {!this.props.hideHeader && (
                    <Typography
                        {...styles.headerText}
                        data-test-selector="autocompleteSuggestions_Header"
                        className="autocomplete-suggestions-header"
                    >
                        {translate("Search")}
                    </Typography>
                )}
                {suggestions.map(suggestion => (
                    /* Store Custom Code - Start */
                    <SuggestionRow key={suggestion.url}>
                        <Icon src={Search} size={16} color="#5C6163" />
                        <Link
                            {...(this.props.focusedItem === suggestion ? styles.focusedLink : styles.link)}
                            onClick={() => {
                                this.props.goToUrl(suggestion.url);
                            }}
                            data-test-selector="autocompleteSuggestions_Result"
                            className="autocomplete-suggestions-link"
                        >
                            {suggestion.displayTitle}
                        </Link>
                        {this.props.onPopulate && (
                            <PopulateButton
                                type="button"
                                title={translate("Fill search with this suggestion")}
                                aria-label={`${translate("Fill search with")} ${suggestion.title}`}
                                data-test-selector="autocompleteSuggestions_populate"
                                onClick={e => {
                                    e.stopPropagation();
                                    this.props.onPopulate!(suggestion.title);
                                }}
                            >
                                ↗
                            </PopulateButton>
                        )}
                    </SuggestionRow>
                    /* Store Custom Code - End */
                ))}
            </>
        );
    }
}

export default AutocompleteSuggestions;
